export default [
  {
    path: '/:organizationId?/:projectId?/profile',
    name: 'profile',
    component: () => import('@/views/profile/Profile.vue'),
    meta: {
      userProfile: true,
      noOrganizationAccess: true,
      pageTitle: 'Profile',
      rule: 'admin',
      breadcrumb: [{ text: 'Profile', active: true }],
    },
  },
  {
    path: '/:organizationId?/:projectId?/profile/update',
    name: 'update-profile',
    component: () => import('@/views/profile/UpdateProfile.vue'),
    meta: {
      userProfile: true,
      noOrganizationAccess: true,
      rule: 'admin',
      pageTitle: 'Profile',
      breadcrumb: [
        { text: 'Profile', to: { name: 'profile' } },
        { text: 'Update Profile', active: true },
      ],
    },
  },
]
